var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("如果您新的功能需求，请联系客服，描述功能要求")]),_vm._v(" "),(false)?_c('el-button',{on:{"click":_vm.startThread}},[_vm._v("发请求拿数据")]):_vm._e(),_vm._v(" "),(false)?_c('span',[_vm._v("状态："+_vm._s(_vm.status))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7ffb3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/custom/Custom.vue
// module id = null
// module chunks = 